// bonus 獎勵
import Image from 'next/image';

const CampaignBonus = ({ prize }) => {
    return (
        <div
            className="relative bonus-bg w-full border-1 border-[#fff] border-opacity-[.3] rounded-[12px] px-[48px] py-[30px]
            between-center gap-x-[40px] overflow-hidden 
            ulg:px-[32px] ulg:py-[24px] umd:flex-col [&>div]:umd:!w-full umd:gap-x-0 umd:gap-y-[20px] usm:!px-[20px]"
        >
            <Image
                className="absolute z-[0] left-[-20%] top-[-30%] w-[50%] mix-blend-lighten umd:top-[-20%] umd:w-[60%] usm:!top-[-10%] usm:!w-[100%] opacity-[.77]"
                width={350}
                height={370}
                src="/images/campaign/bonus_background.png"
                alt="background"
            />

            <div className="text-white space-y-[12px] w-[calc((100%-40px)/2)] ulg:w-[55%]">
                <p className="text-h5">轉盤 Bonus 特殊獎勵</p>
                <p className="text-bd1m">
                    抽取獎券的幸運轉盤設有特殊Bonus區
                    <br />
                    每次轉動都有機會獲得額外特殊獎勵
                </p>
            </div>

            <div className="flex items-center gap-x-[24px] w-[calc((100%-40px)/2)]">
                {/* 獎品圖 */}
                <div className="img-box w-[113px] aspect-[1/1] rounded-[12px] after:content-none flex-shrink-0">
                    <Image width={110} height={110} src={prize?.image} alt={prize?.name} />
                </div>

                <div className="space-y-[20px]">
                    {/* 獎品名稱 */}
                    <p className="text-btn3b text-white">{prize?.name}</p>

                    {/* 獎品數量 */}
                    <p className="text-btn1 text-[#c7c7c7]">{prize?.desc}</p>
                </div>
            </div>
        </div>
    );
};

export default CampaignBonus;
